'use strict';

const isMedium = require('../utils/isMedium');

(function initHeaderMenu() {
	const $mainMenu = $('.main-menu');
	const SCROLL_LOCK_CLASS = 'is-menu-open';

	function lockScroll() {
		$('body').addClass('overflow-hidden');
	}
	function unlockScroll() {
		if (!$('.drawer.is-open').length) {
			$('body').removeClass('overflow-hidden');
		}
	}

	function syncDesktopDdMenuPageScrollLock() {
		if (!isMedium()) {
			return;
		}
		const hasOpenDesktopDd = $mainMenu.find('.dd.is-open').length > 0;
		if (hasOpenDesktopDd) {
			lockScroll();
			return;
		}
		unlockScroll();
	}

	/**
	 * Lock document scroll only when a L1 dropdown panel is open on mobile (full-screen .dd__menu).
	 * While the drawer is open without a dropdown, the menu list can scroll; the browser page stays scrollable.
	 */
	function syncMobileDropdownBodyScrollLock() {
		if (isMedium()) {
			$('html, body').removeClass('overflow-hidden');

			return;
		}

		const menuVisible = !$mainMenu.hasClass('d-none');
		const dropdownOpen = $mainMenu.find('.dd.is-open').length > 0;
	}

	const mainMenuEl = $mainMenu.get(0);
	if (mainMenuEl) {
		const mo = new MutationObserver(syncMobileDropdownBodyScrollLock);
		mo.observe(mainMenuEl, { subtree: true, attributes: true, attributeFilter: ['class'] });
	}

	let resizeTimer;

	/**
	 * Desktop only: cap each dd__menu to the real viewport space left under its current top.
	 */
	function syncDesktopDdMenuAvailableHeight() {
		if (!isMedium()) {
			$mainMenu.find('.dd__menu').css('--lvz-mega-menu-available-height', '');
			return;
		}

		const viewportHeight = window.innerHeight || $(window).height();
		const safeBottom = 8;

		$mainMenu.find('.dd__menu').each(function () {
			const rect = this.getBoundingClientRect();
			const available = Math.max(0, Math.floor(viewportHeight - rect.top - safeBottom));
			this.style.setProperty('--lvz-mega-menu-available-height', `${available}px`);
		});
	}

	function getViewportHeight() {
		return window.visualViewport ? window.visualViewport.height : window.innerHeight || $(window).height();
	}

	function getMobileHeaderMetrics() {
		const headerBar = $('.main-header-bar').get(0);
		const headerTemplate = $('#lvz-header-template').get(0);
		const topBanner = $('#lvz-top-banner').get(0);
		const headerBarRect = headerBar ? headerBar.getBoundingClientRect() : null;
		const headerTemplateRect = headerTemplate ? headerTemplate.getBoundingClientRect() : null;
		const headerBottom = headerBarRect ? Math.max(0, Math.floor(headerBarRect.bottom)) : 0;

		if (headerBottom > 0) {
			return {
				viewportTop: headerBottom,
				headerRelativeTop: headerTemplateRect ? Math.max(0, Math.floor(headerBottom - headerTemplateRect.top)) : headerBottom,
			};
		}

		const headerH = $('.main-header-bar').innerHeight() || 0;
		const topBannerH = topBanner ? $(topBanner).innerHeight() || 0 : 0;

		return {
			viewportTop: headerH + topBannerH,
			headerRelativeTop: headerH,
		};
	}

	function scheduleDesktopDdMenuAvailableHeightSync() {
		// Run after layout settles (dropdown open state + sticky/header repaint).
		requestAnimationFrame(function () {
			requestAnimationFrame(syncDesktopDdMenuAvailableHeight);
		});
		setTimeout(syncDesktopDdMenuAvailableHeight, 120);
	}

	/**
	 * Full-viewport L1 .dd__menu on mobile: height + top from header and top banner.
	 * @param {JQuery<HTMLElement>} $ddMenu The .dd__menu next to the clicked .dd__toggle (or the open panel's menu)
	 */
	function applyMobileDdMenuLayout($ddMenu) {
		if (!$ddMenu || !$ddMenu.length) {
			return;
		}
		if (isMedium()) {
			$ddMenu.css({ height: '', top: '' });
			return;
		}

		const vh = getViewportHeight();
		const topOffset = getMobileHeaderMetrics().viewportTop;
		const menuH = vh - topOffset;

		$ddMenu.css({
			height: menuH,
			top: topOffset,
		});
	}

	function clearMobileDdMenuLayoutAll() {
		$mainMenu.find('.dd__menu').css({ height: '', top: '' });
	}

	/** Reapply to the L1 menu panel that is open on mobile (e.g. after resize or search bar toggle). */
	function reapplyOpenMobileDdMenuLayout() {
		if (isMedium()) {
			clearMobileDdMenuLayoutAll();
			return;
		}
		const $openMenu = $mainMenu.find('.dd.is-open .dd__menu').first();
		if ($openMenu.length) {
			applyMobileDdMenuLayout($openMenu);
		}
	}

	/** Reapply full-screen main menu on mobile when header / top banner height changes (e.g. search bar toggle, resize). */
	function reapplyOpenMobileMainMenuLayout() {
		if (isMedium()) {
			$mainMenu.css({ height: '', top: '' });
			return;
		}
		if ($mainMenu.hasClass('d-none')) {
			return;
		}
		applyMobileMainMenuLayout($mainMenu);
	}

	function applyMobileMainMenuLayout($menu) {
		if (!$menu || !$menu.length) {
			return;
		}
		if (isMedium()) {
			$menu.css({ height: '', top: '' });
			return;
		}

		const vh = getViewportHeight();
		const headerMetrics = getMobileHeaderMetrics();
		const topOffset = headerMetrics.headerRelativeTop;
		const menuH = vh - headerMetrics.viewportTop;

		$menu.css({
			height: menuH,
			top: topOffset,
		});
	}

	// left menu toggle
	$('.navbar-toggler').click(function (e) {
		e.preventDefault();
		// scroll to .lavazza-navbar-container, wait after continue
		//$('.lavazza-navbar-container').get(0).scrollIntoView({ behavior: 'smooth' });

		setTimeout(() => {
			const $menu = $('.main-menu');
			const isOpening = $menu.hasClass('d-none');

			$('html').toggleClass(SCROLL_LOCK_CLASS, isOpening);
			if (isOpening) {
				lockScroll();
			} else {
				unlockScroll();
			}

			applyMobileMainMenuLayout($menu);

			$menu.toggleClass('d-none', !isOpening);
			$('.lavazza-navbar-container').toggleClass('opened-main-menu', isOpening);
			$('.modal-background').toggle(isOpening);

			$menu.attr('aria-hidden', isOpening ? 'false' : 'true');
			$menu.siblings().attr('aria-hidden', isOpening ? 'true' : 'false');
			$('header').siblings().attr('aria-hidden', isOpening ? 'true' : 'false');
			$menu.removeClass('overflow-hidden');
		}, 300);
		// change icon to cross
		const isMenuOpening = $('.main-menu').hasClass('d-none');
		$(this).find('i')
			.toggleClass('icon-menu-4', !isMenuOpening)
			.toggleClass('icon-close', isMenuOpening);
	});

	$(window).on('resize', () => {
		clearTimeout(resizeTimer);
		resizeTimer = setTimeout(() => {
			syncMobileDropdownBodyScrollLock();
			syncDesktopDdMenuPageScrollLock();
			reapplyOpenMobileDdMenuLayout();
			reapplyOpenMobileMainMenuLayout();
			syncDesktopDdMenuAvailableHeight();
		}, 150);
	});

	if (window.visualViewport) {
		$(window.visualViewport).on('scroll resize', () => {
			clearTimeout(resizeTimer);
			resizeTimer = setTimeout(() => {
				reapplyOpenMobileDdMenuLayout();
				reapplyOpenMobileMainMenuLayout();
			}, 50);
		});
	}

	setTimeout(scheduleDesktopDdMenuAvailableHeightSync, 0);

	/**
	 * L1 .dd__menu tied to the clicked .dd__toggle (sibling .dd__background-overlay-menu .dd__menu).
	 * Runs after dropdown.js toggles .is-open.
	 */
	$(document).on('click', '.main-menu .dd__toggle', function onDdToggleForMobileLayout() {
		scheduleDesktopDdMenuAvailableHeightSync();
		setTimeout(syncDesktopDdMenuPageScrollLock, 0);

		if (isMedium()) {
			return;
		}
		const $toggle = $(this);
		const $ddMenu = $toggle.next().find('.dd__menu');

		setTimeout(function applyAfterDdState() {
			scheduleDesktopDdMenuAvailableHeightSync();
			if (isMedium()) {
				return;
			}
			const isOpen = $toggle.closest('.dd').hasClass('is-open');
			if (isOpen) {
				applyMobileDdMenuLayout($ddMenu);
			} else {
				$ddMenu.css({ height: '', top: '' });
			}
			syncDesktopDdMenuPageScrollLock();
		}, 0);
	});

	$(document).on('click', '.search-button-toggle', function onSearchToggleRecalcLayout() {
		if (isMedium()) {
			return;
		}

		setTimeout(function onSearchToggleRecalcLayoutAfterPaint() {
			reapplyOpenMobileDdMenuLayout();
			reapplyOpenMobileMainMenuLayout();
		}, 0);
	});

	$(document).on('lavazza:headerSearchLayoutChange', function onHeaderSearchLayoutChange() {
		if (isMedium()) {
			return;
		}

		setTimeout(function onHeaderSearchLayoutChangeAfterPaint() {
			reapplyOpenMobileDdMenuLayout();
			reapplyOpenMobileMainMenuLayout();
		}, 0);
	});

	// Mobile: pulsante "indietro" nel pannello dd__menu chiude il dropdown L1 aperto
	$(document).on('click', '.turn-back-button', function onTurnBackClick(e) {
		e.preventDefault();
		e.stopPropagation();
		const $dd = $(this).closest('.dd');
		$dd.removeClass('is-open');
		$dd.find('.dd__toggle').attr('aria-expanded', 'false');
		$dd.find('.dd__menu').css({ height: '', top: '' });
		syncMobileDropdownBodyScrollLock();
		syncDesktopDdMenuPageScrollLock();
		$dd.find('.dd__toggle').focus();
		$('.main-menu').removeClass('overflow-hidden');
	});
})();
